import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useList(path, { pageSize = 25, filters = {} } = {}) {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const filterKey = JSON.stringify(filters);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, page_size: pageSize, ...JSON.parse(filterKey) };
      if (q) params.q = q;
      const res = await api.get(path, { params });
      setData(res.data);
    } finally {
      setLoading(false);
    }
  }, [path, page, pageSize, q, filterKey]);

  useEffect(() => {
    const t = setTimeout(reload, 200);
    return () => clearTimeout(t);
  }, [reload]);

  useEffect(() => setPage(1), [q, filterKey]);

  return { ...data, loading, reload, q, setQ, page, setPage, pageSize };
}
